import logger from 'utils/logger';

const importMap = {
  de_CH: () => import('state/translations/de_CH.json'),
  de_DE: () => import('state/translations/de_DE.json'),
  de: () => import('state/translations/de.json'),
  en_CA: () => import('state/translations/en_CA.json'),
  en_CH: () => import('state/translations/en_CH.json'),
  en_GB: () => import('state/translations/en_GB.json'),
  en_ZA: () => import('state/translations/en_ZA.json'),
  en_US: () => import('state/translations/en.json'),
  en: () => import('state/translations/en.json'),
  fr_CA: () => import('state/translations/fr_CA.json'),
  fr_CH: () => import('state/translations/fr_CH.json'),
  fr: () => import('state/translations/fr.json'),
  it_CH: () => import('state/translations/it_CH.json'),
  it: () => import('state/translations/it.json'),
};

export async function getMessagesForLanguage(language: string, region: string) {
  let regionLocale;
  let baseLocale;

  try {
    regionLocale = await importMap[`${language}_${region}`]();
  } catch (e) {
    logger.warn(e);
  }

  try {
    baseLocale = await importMap[language]();
  } catch (e) {
    logger.warn(e);
  }

  return { ...(baseLocale || {}), ...(regionLocale || {}) };
}
